import { useEffect } from "react";
import LoginBox from "../components/login/LoginBox";

export default function LoginPage() {
    useEffect(() => {
        document.title = "Login"
    }, []);

    return <LoginBox />;
}